<template lang="pug">
  ui-icon(name='loading' v-if='loading').ml
  ui-icon(name='edit' v-else-if='editing').ml
  ui-icon(name='check' v-else-if='vDone').ml
</template>

<script>
export default {
  name: 'LoadingIndicator',
  props: {
    loading: { type: Boolean, default: false },
    editing: { type: Boolean, default: false },
    done: { type: Boolean, default: false },
  },
  emits: ['update:done'],
  data() {
    return {
      vDone: false,
      ti: null,
    };
  },
  watch: {
    done(next, prev) {
      if (next && !prev) {
        this.vDone = true;
        clearTimeout(this.ti);
        this.ti = setTimeout(() => {
          this.vDone = false;
          this.$emit('update:done', this.vDone);
        }, 1500);
      }
    },
  },
};
</script>
